import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchOrderReceipt } from "../../../Redux/Action/orderReceiptAction";
import OrderReceipt from "./OrderReceipt";
import { plus_icon, send_icon } from "../../../assets/";
import { clearProducts } from "../../../Redux/Action/productsAction";
import { clearCustomer } from "../../../Redux/Action/getcustomerAction";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { useTranslation } from "react-i18next";
import OrderReceiptPDF from "./OrderReceiptPDF";
import { clearReturnProducts } from "../../../Redux/Action/returnproductAction";
import { clearPaymentMethod } from "../../../Redux/Action/paymentAction";
import { detectWebDeviceType, isTablet } from "../../../utils";
import { toast } from "react-toastify";

const SESSION_STORAGE_KEY = "products";
const RETURN_PRODUCTS = "returnProductReducer";

function ReceiptOption({ option, icon }) {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex gap-5 py-1.5 pr-1 pl-6 mt-8 text-base text-black-400 bg-white rounded-lg max-md:flex-wrap max-md:pl-5 max-md:max-w-full">
      <input
        type="text"
        placeholder={t(option)}
        className="flex-auto my-auto outline-none"
      />
      <img
        src={send_icon}
        alt=""
        className={`shrink-0 rounded-md aspect-[1.59] w-[93px] cursor-pointer transition-transform transform ${
          i18n.language == "ar" ? "scale-x-[-1]" : ""
        }`}
        onClick={() => console.log("Send receipt")}
      />
    </div>
  );
}

function OrderCheckout() {
  const { t, i18n } = useTranslation();
  const [receiptData, setReceiptData] = useState();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.login);
  const store_id = user?.store_id;
  const navigate = useNavigate();
  // const { order_id } = useParams();
  const order_id = new URLSearchParams(window.location.search).get("order_id");
  const userData = useSelector((state) => state?.login?.user?.result);
const [printCount, setPrintCount] = useState(0);
  // Auto print window
 const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled
  );
  useEffect(() => {
    if (receiptData?.order[0]?.order_no) {
        const isElectron = window.electronAPI?.isElectron;
  const isReactNativeWebView =
    window.ReactNativeWebView &&
    typeof window.ReactNativeWebView.postMessage === "function";
if(isElectron || isReactNativeWebView){
      handlePrintReceipt();
}
    }
  }, [receiptData?.order[0]?.order_no]);

  useEffect(() => {
    const getReceiptData = async () => {
      try {
        if (order_id) {
          //   const data = await dispatch(fetchOrderReceipt(Number(order_id)));
          const response = await axiosInstance.post(
            URLS.RECEIPT_ORDER_DETAILS,
            {
              lang: i18n.language === "ar" ? "ar_001" : "en_US",
              order_id: Number(order_id),
            }
          );
          if (response?.data?.result?.state == "success") {
            // console.log("response.data.result", response?.data?.result?.order[0]);
            setReceiptData(response?.data?.result);
            if(printCount == 0){
            setPrintCount(1);
               const isElectron = window.electronAPI?.isElectron;
  if (isElectron && window.electronAPI?.sendReceiptData) {
            handlePrint(response?.data?.result, userData)
  }
            }
            dispatch(clearProducts());
            dispatch(clearCustomer());
            dispatch(clearPaymentMethod());
          }
        } else {
          console.error("No order_id found");
        }
      } catch (error) {
        console.error("Error fetching receipt data:", error);
      }
    };

    getReceiptData();
  }, [order_id, dispatch]);

  const receiptOptions = [{ option: "WhatsApp number", icon: "" }];

const handlePrintReceipt = () => {
  if (!receiptData) {
    console.error("Receipt data is not available for printing.");
    return;
  }

  const isElectron = window.electronAPI?.isElectron;
  const isReactNativeWebView =
    window.ReactNativeWebView &&
    typeof window.ReactNativeWebView.postMessage === "function";

  // Electron
  if (isElectron && window.electronAPI?.sendReceiptData) {
    handlePrint(receiptData, userData);
    return;
  }

  // ✅ Android WebView
  if (isReactNativeWebView) {
    // const html = OrderReceiptPDF(
    //   receiptData,
    //   t,
    //   i18n.language,
    //   userData,
    //   "",
    //   isETAenabled
    // );

    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "PRINT_RECEIPT",
        payload: receiptData,
      })
    );
    return;
  }

  // Browser
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";

  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(OrderReceiptPDF(receiptData, t, i18n.language, userData,"", isETAenabled));
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  }, 1000);
};



  // useEffect(() => {
  //   const handlePrintMessage = () => {
  //     handlePrintReceipt();
  //   };

  //   // Set up the IPC listener
  //   window.electron.ipcRenderer.on("print-receipt", handlePrintMessage);

  //   // Cleanup the listener on component unmount
  //   return () => {
  //     window.electron.ipcRenderer.removeListener("print-receipt", handlePrintMessage);
  //   };
  // }, [receiptData]);

  // const handlePrintReceipt = () => {
  //   const printWindow = window.open("", "_blank");

  //   if (printWindow) {
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Receipt</title>
  //           <style>

  //             body { font-family: Arial, sans-serif; }
  //             h1, h2, h3 { text-align: center; }

  //           </style>
  //         </head>
  //         <body>
  //           ${OrderReceiptPDF(receiptData, t, i18n.language, userData)}
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //     printWindow.focus();

  //     // Use a timeout to ensure the document is fully loaded before printing
  //     setTimeout(() => {
  //       printWindow.print();
  //       printWindow.close();
  //     }, 1000);
  //   } else {
  //     console.error("Failed to open print window. Please check your popup blocker settings.");
  //   }
  // };

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Normalize key input for consistent handling
      const normalizedKey =
        {
          " ": "Space", // Space key normalization
          Shift: "Shift", // Shift key normalization
          p: "ح", // Ctrl+P key normalization
        }[event.key] || event.key; // Fallback to the original key if no mapping exists

      if (event.ctrlKey && normalizedKey === "ح") {
        event.preventDefault();
        handlePrintReceipt();
      } else if (normalizedKey === "Space") {
        event.preventDefault();
        handleNewOrderClick();
      } else if (normalizedKey === "Shift") {
        event.preventDefault();
        handleFinishClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [receiptData]);

  const handleNewOrderClick = () => {
    localStorage.removeItem(SESSION_STORAGE_KEY);
    dispatch(clearReturnProducts());
    navigate("/session");
  };

  const handleFinishClick = () => {
    localStorage.removeItem(SESSION_STORAGE_KEY);
    dispatch(clearReturnProducts());
    navigate("/dashboard");
  };

  const handleResendClick = async () => {
    // const params = new URLSearchParams(window.location.search);
    // const orderid = params.get("orderid");
    const order_id = receiptData?.order[0]?.id;
    console.log(order_id,"order_id))))))))))");
    

    try {
      const response = await axiosInstance.post(URLS.SEND_CUSTOMER_SMS, {
        order_id,
      });
console.log("resend recipt api" ,response);

      if (
        response.data &&
        response.data.result &&
        response.data.result.status_code === 200
      ) {
        toast.success(t("Message sent Successfully"));
      } else {
        toast.error(t(response.data.result.status));
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred while sending the message");
    }
  };

//   const params = new URLSearchParams(window.location.search);
//   const orderid = params.get("orderid");
//   const Porder_id = Number(orderid);
  
// console.log(receiptData,"receiptData");

const deviceType = detectWebDeviceType();

const handlePrint = async(data, user) => {
  
  // const receipt = {
  //   receiptData: data,
  //   userData: userData,
  //   language:i18n.language
  // };
const html = await OrderReceiptPDF(data, t, i18n.language, user,"", isETAenabled);
  if (window.electronAPI?.sendReceiptData) {
    window.electronAPI.sendReceiptData(html);
  } else {
    console.warn("electronAPI.sendReceiptData is not available");
  }
};
  return (
    <>
      <div className="flex">
        <div className="flex justify-center max-md:flex-col max-md:gap-0 w-[70%] ">
          <div className="mt-28 w-[60%]">
            <div className="flex flex-row justify-between ms-5 me-5 ">
              {receiptData?.order[0].customer && (
                <div className="text-lg">
                  {t("Customer Name")} <br></br>
                  <span className="text-black font-semibold text-xl">
                    {isNaN(parseFloat(receiptData?.order[0].customer)) &&
                    !/^\d{3}[-.]?\d{3}[-.]?\d{4}$/.test(
                      receiptData?.order[0].customer
                    )
                      ? receiptData?.order[0].customer
                      : "--"}
                  </span>
                  {/* <span className="text-black font-semibold text-xl">
                    {Porder_id}{Porder_idh}
                  </span> */}
                </div>
              )}
              {/* {receiptData?.order[0].customer_mobile && (
                <div className="text-lg">
                  {t("Phone Number")} <br></br>
                  <span className="text-black font-semibold text-xl">
                    {receiptData?.order[0].customer_mobile}
                  </span>
                </div>
              )} */}
            </div>
            <section className="flex flex-col px-5  text-xl max-md:mt-10 max-md:max-w-full">
             
              {/* {deviceType == "pc" && (
                <> */}
                 <h2 className="mt-24 text-2xl font-bold tracking-wide leading-none text-zinc-800 max-md:mt-10 max-md:max-w-full">
                <span className="text-zinc-800">
                  {t("How would you like to receive the receipt?")}
                </span>
              </h2>
                <button
                  className="justify-center items-center px-16 py-4 mt-8 font-semibold tracking-wide leading-10 text-center text-white bg-[#FABF01] border border-solid border-stone-300  capitalize rounded-lg max-md:px-5 max-md:max-w-full"
                  onClick={handlePrintReceipt}
                >
                  {t("Print Receipt")}
                </button>
                {/* </>
              )} */}
              {/* here isTbalet condition is based on width so of u ooen inspect in web than 
              the size of screen reduces due to which this resenc button will be shown */}
              {/* { receiptData?.order[0]?.uniq_code_pos && deviceType != "pc" &&(
                <>
                 <h2 className="mt-24 text-2xl font-bold tracking-wide leading-none text-zinc-800 max-md:mt-10 max-md:max-w-full">
                <span className="text-zinc-800">
                  {t("How would you like to receive the receipt?")}
                </span>
              </h2>
                <button
                  className="justify-center items-center px-16 py-4 mt-8 font-semibold tracking-wide leading-10 text-center text-white bg-[#FABF01] border border-solid border-stone-300  capitalize rounded-lg max-md:px-5 max-md:max-w-full"
                  onClick={handleResendClick}
                >
                  {t("Resend Receipt")}
                </button>
                </>
              )} */}
              <div className="flex flex-row w-full justify-between mt-4">
                <button
                  className={`justify-center items-center w-[50%] py-4 mt-8 font-semibold tracking-wide leading-10 text-center text-[#1b4597] bg-white border border-[#1b4597] border-2 border-solid capitalize rounded-lg max-md:px-5 max-md:max-w-full ${
                    i18n.language === "ar" ? "ms-2" : "me-2"
                  }`}
                  onClick={handleFinishClick}
                >
                  {t("Finish")}
                </button>

                <button
                  className="justify-center items-center w-[50%] py-4 mt-8 font-semibold tracking-wide leading-10 text-center text-white bg-[#1b4597] border capitalize rounded-lg max-md:px-5 max-md:max-w-full"
                  onClick={handleNewOrderClick}
                >
                  {t("New Order")}
                </button>
              </div>
            </section>
          </div>
          {/* <NewOrderButton /> */}
        </div>
        {receiptData && <OrderReceipt receiptData={receiptData} />}
      </div>
    </>
  );
}

export default OrderCheckout;
